import { css } from "@emotion/react";

export const BrokenImage = () => {
  return <div css={rootStyles}>Failed to load the image</div>;
};

const rootStyles = css({
  backgroundColor: "red",
  padding: "10px",
  color: "white",
});
